if (!customElements.get('testimonial-carousel')) {
  class TestimonialCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.currentLabel = this.querySelector('[data-current]');
      this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));

      if (this.slides.length < 2) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const inEditor = window.Shopify && Shopify.designMode;
      this.autoplayEnabled = this.dataset.autoplay === 'true' && !reducedMotion && !inEditor;
      this.interval = (parseInt(this.dataset.interval, 10) || 6) * 1000;
      this.timer = null;

      this.onPrev = () => this.go(this.index - 1, true);
      this.onNext = () => this.go(this.index + 1, true);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onPointerDown = this.handlePointerDown.bind(this);
      this.onPointerUp = this.handlePointerUp.bind(this);
      this.onPause = () => this.stop();
      this.onResume = () => this.start();
      this.onFocusOut = (e) => {
        if (!this.contains(e.relatedTarget)) this.start();
      };
      this.onBlockSelect = (e) => {
        const i = this.slides.indexOf(e.target.closest('[data-slide]'));
        if (i > -1) this.go(i);
        this.stop();
      };
      this.onBlockDeselect = () => this.start();

      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);
      this.addEventListener('keydown', this.onKeydown);
      this.track.addEventListener('pointerdown', this.onPointerDown);
      this.track.addEventListener('pointerup', this.onPointerUp);
      this.addEventListener('mouseenter', this.onPause);
      this.addEventListener('mouseleave', this.onResume);
      this.addEventListener('focusin', this.onPause);
      this.addEventListener('focusout', this.onFocusOut);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.go(this.index);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.slides.length < 2) return;
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.removeEventListener('keydown', this.onKeydown);
      this.track?.removeEventListener('pointerdown', this.onPointerDown);
      this.track?.removeEventListener('pointerup', this.onPointerUp);
      this.removeEventListener('mouseenter', this.onPause);
      this.removeEventListener('mouseleave', this.onResume);
      this.removeEventListener('focusin', this.onPause);
      this.removeEventListener('focusout', this.onFocusOut);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    go(target, userTriggered = false) {
      const total = this.slides.length;
      this.index = ((target % total) + total) % total;

      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.toggleAttribute('inert', !active);
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      if (this.currentLabel) this.currentLabel.textContent = String(this.index + 1);

      // Restart the countdown after manual navigation so the next slide
      // doesn't appear a moment after someone clicks.
      if (userTriggered && this.timer) this.start();
    }

    start() {
      if (!this.autoplayEnabled) return;
      this.stop();
      this.track.setAttribute('aria-live', 'off');
      this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
      this.track?.setAttribute('aria-live', 'polite');
    }

    handleKeydown(e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.go(this.index - 1, true);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.go(this.index + 1, true);
      }
    }

    handlePointerDown(e) {
      this.startX = e.clientX;
      this.startY = e.clientY;
    }

    handlePointerUp(e) {
      if (this.startX == null) return;
      const dx = e.clientX - this.startX;
      const dy = e.clientY - this.startY;
      this.startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        this.go(this.index + (dx < 0 ? 1 : -1), true);
      }
    }
  }

  customElements.define('testimonial-carousel', TestimonialCarousel);
}
